export default function initBtnBack () {
	const btn = document.querySelector('#button-back__history');
	if (!btn) return;
    if (history.length > 2) btn.classList.remove('hidden');
}
